export default "__VITE_ASSET__Bq6y0qnT__"